<template>  
    <section :style="{ height: wrapperHeight + 'px' }" class="list">
		<div class="tabs sale">
			<span :class='selectFlag==1?"select-flag":""' @click='changeNews("1")'>我的消息<span v-if="unRead" class="un-read"></span></span>
			<span :class='selectFlag==2?"select-flag":""' @click='changeNews("2")'>系统消息<span v-if="notRead" class="un-read"></span></span>
		</div>
		
		<mt-loadmore v-if="newsList && newsList.length" :bottom-method="loadBottom" :auto-fill="false" :bottom-all-loaded="allLoaded" ref="loadmore" :bottomPullText='"加载更多"' :bottomLoadingText='"加载中"' :bottomDropText='"释放加载"'>
			<ul>
				<li class="news-wrap"  v-for="(item,index) in newsList" :key="index" @click="detail(item)">
					<span class="text">{{item.title}}<span class="un-read" v-if="item.is_read==1"></span></span>
					<span class="time">{{item.create_time}}</span>
					<p class="name" v-html="item.content" v-if="newsType==1"></p>
				</li>
			</ul>
		</mt-loadmore>
		
		<div v-else>
			<div class="no-order">
				<img src="../../assets/images/no-news.png">
                <p>暂无消息</p>
			</div>
		</div>
    </section>
</template>

<script>
    import CommonHeader from '@/components/CommonHeader'
    import utils from '@/assets/jslibs/utils'
    import {getUserMessage,getMessageDetail} from '@/api/personal'
    export default {
        name: 'index',
		data(){
			return{
				wrapperHeight:0,
				allLoaded:false,
				newsType:"1",         //默认是用户消息
				selectFlag:true,
				newsList:[],
                unRead:false,
                notRead:false,
				 body: {
				  page_index: 1,
				  page_size: 10,
				},
			}
		},
        components: {
            CommonHeader,
        },
        
        beforeCreate(){
        	sessionStorage.setItem("roleType","customer")
        },
       
        created() {
			this.getUserMessage("1");
            this.getSystermMess("2");
        },
		mounted(){
		    this.wrapperHeight = document.documentElement.clientHeight;
            document.title = "我的消息"
		},
        
        methods: {
			async getUserMessage(type){
				let obj={type:type,page_index:this.body.page_index,page_size:this.body.page_size};
			    const { data, status } = await getUserMessage(obj);
			    if (status !== 200) return 
				this.newsList = data.data;
				if(this.newsList && this.newsList.length){
					this.newsList.forEach((item,index)=>{
						if(item.create_time.length>10){
							item.create_time = item.create_time.slice(0,10)
						}
                        
                        if(type==1){
                            if(item.is_read=="1"){
                               this.unRead = true
                            } 
                        }else{
                            if(item.is_read=="1"){
                               this.notRead = true
                            } 
                        }
                        
					})
					
					this.body.page_index += 1;
				}
			},
            
            // 获取是否有未读系统消息
            async getSystermMess(type){
            	let obj={type:type,page_index:this.body.page_index,page_size:this.body.page_size};
                const { data, status } = await getUserMessage(obj);
                if (status !== 200) return 
            	if(data.data && data.data.length){
            		data.data.forEach((item,index)=>{
                        if(item.is_read=="1"){
                            this.notRead = true
                        }
            		})
            	}
            },
            
			loadBottom(){
			    this.$refs.loadmore.onBottomLoaded();
			    this.$refs.loadmore.onTopLoaded();
			    this.loadMore()
			},
			
			async loadMore(){
				let obj={type:this.newsType,page_index:this.body.page_index,page_size:this.body.page_size};
			    const { data, status } = await getUserMessage(obj);
			    if( status !== 200) return
			    if(data.data.length){
			        this.body.page_index += 1
			        this.newsList = this.newsList.concat(data.data);
					this.newsList.forEach((item,index)=>{
						if(item.create_time.length>10){
							item.create_time = item.create_time.slice(0,10)
						}
                        if(this.newsType==1){
                            if(item.is_read=="1"){
                               this.unRead = true
                            } 
                        }else{
                            if(item.is_read=="1"){
                               this.notRead = true
                            } 
                        }
					})
			    }
				else{
			        window.toast("没有更多数据","txt");
			    }
			},
			
            navigateTo(path){
                this.$router.push(path)
            },
			
			// 切换消息类型
			changeNews(type){
				this.newsType = type;             //判断是系统消息还是用户消息
				this.selectFlag=type;
                this.body.page_index = 1;
				this.newsList =[];
                if(this.newsType == 1){
                    document.title = "我的消息"
                }else{
                    document.title = "系统消息"
                }
				this.getUserMessage(type)
			},
            
            async getMessageDetail(uuid){
                const { data, status } = await getMessageDetail(uuid);
                if (status !== 200) return 
            	this.detail=data;
            },
			
			// 查看消息
			detail(item){
				if(this.newsType=="1"){//用户消息
                    this.getMessageDetail(item.uuid)
					this.$router.push({path:"./order-detail",query:{order_uuid:item.order_uuid}})
				}else if(this.newsType=="2"){//系统消息
					this.$router.push({path:"./news-detail",query:{order_uuid:item.uuid}})
				}
			}
        },
    }
</script>

<style lang='less' scoped>
	@import '~@/assets/styles/variable.less';
	@import '~@/assets/styles/handleMethods.less';
	@import '~@/assets/styles/reset.css';
    section{font-family:PingFangSC-Regular;;font-weight:400;background: #fff}
	.no-order{width: 68px;height:58px;margin: 0 auto;margin-top:50%;margin-bottom: 50%}
	.no-order img{width: 100%;height: 100%}
    .no-order p{text-align: center;font-size:13px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(207,207,207,1);line-height:18.5px;margin-top: 10.5px}
	.list{overflow-y: scroll; width: 100%;height:100%;}
	.tabs{height: 44px;border-bottom: 1px solid #EEEEEE;padding: 0 68px;display: -webkit-box;display: -ms-flexbox;display: flex;justify-content: space-between;align-items: center}
	.tabs span{position: relative;color:rgba(51,51,51,1);font-size: 16px;height: 44px;line-height: 44px;}
    .tabs .select-flag{color:rgba(65,132,244,1);border-bottom: 2px solid #4184F4;font-family:PingFangSC-Medium;font-weight:500;}
    .tabs .un-read{display: block;width: 7px;height: 7px;border-radius: 50%;background: red;position: absolute;top:10px;right:-8px}
	.text .un-read{display: block;width: 7px;height: 7px;border-radius: 50%;background: red;position: absolute;top:0;right:-12px}
    
    .news-wrap{border-bottom: 1px solid #EEEEEE;padding: 11px 13px 14px 16px;}
	.text{font-family:PingFangSC-Medium;font-weight:500;color:rgba(20,20,20,1);font-size: 14px;position: relative}
	.time{color:rgba(153,153,153,1);font-size: 11px;float: right;}
	.name{color:rgba(153,153,153,1);font-size: 13px;margin-top: 4px}
</style>
